<template>
    <Listbox as="div" class="min-w-full" v-model="selected" multiple>
        <ListboxLabel
            v-if="label"
            class="text-foreground mb-1 block text-sm font-medium"
            >{{ label }}</ListboxLabel
        >
        <div class="relative min-w-full">
            <ListboxButton
                v-slot="{ open }"
                class="border-input dark:bg-input/30 dark:hover:bg-input/50 flex h-9 w-full items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-left text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
            >
                <span
                    class="block truncate"
                    :class="
                        selected.length > 0 ? '' : 'text-muted-foreground'
                    "
                    >{{
                        selected.length > 0 ? selectedOptions : placeholder
                    }}</span
                >
                <span class="flex shrink-0 items-center gap-1.5">
                    <span
                        v-if="selected.length > 0"
                        class="rounded bg-indigo-500/15 px-1.5 py-0.5 text-[11px] font-semibold text-indigo-500"
                        >{{ selected.length }}</span
                    >
                    <ChevronDownIcon
                        :class="{ 'rotate-180': open }"
                        class="text-muted-foreground size-4 transition-all"
                        aria-hidden="true"
                    />
                </span>
            </ListboxButton>

            <transition
                leave-active-class="transition ease-in duration-100"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <ListboxOptions
                    class="bg-popover text-popover-foreground absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md border p-1 text-sm shadow-md focus:outline-none"
                >
                    <ListboxOption
                        as="template"
                        v-for="option in options"
                        :key="option.value"
                        :value="option.value"
                        v-slot="{ active, selected }"
                    >
                        <li
                            :class="[
                                active ? 'bg-accent text-accent-foreground' : '',
                                'relative flex cursor-pointer items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 select-none',
                            ]"
                        >
                            <span
                                :class="[
                                    selected
                                        ? 'font-medium text-indigo-500'
                                        : 'font-normal',
                                    'block truncate',
                                ]"
                            >
                                {{ option.label }}
                            </span>
                            <span
                                v-if="selected"
                                class="absolute inset-y-0 right-2 flex items-center text-indigo-500"
                            >
                                <CheckIcon class="size-4" aria-hidden="true" />
                            </span>
                        </li>
                    </ListboxOption>
                </ListboxOptions>
            </transition>
        </div>
    </Listbox>
</template>

<script>
import { CheckIcon, ChevronDownIcon } from "@heroicons/vue/24/outline";
import {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    ListboxLabel,
} from "@headlessui/vue";

export default {
    components: {
        ListboxLabel,
        Listbox,
        ListboxButton,
        ListboxOptions,
        ListboxOption,
        ChevronDownIcon,
        CheckIcon,
    },
    props: {
        label: { type: String, required: false },
        placeholder: { type: String, required: false },
        options: { type: Array, required: true },
        modelValue: { required: true },
    },

    data() {
        return {
            selected: this.modelValue,
        };
    },

    computed: {
        selectedOptions() {
            return this.selected
                .map((value) => {
                    const option = this.options.find(
                        (option) => option.value === value
                    );
                    return option ? option.label : "";
                })
                .join(", ");
        },
    },

    watch: {
        selected(value) {
            this.$emit("update:modelValue", value);
        },
        modelValue(value) {
            this.selected = value;
        },
    },
};
</script>
